
export enum PublicTransportDownloadSourceStatus {
    Failed = 0,
    Success = 1,
    Ignored = 2,
    Patched = 3
}

export const getPublicTransportDownloadSourceStatusLabel = (importType: PublicTransportDownloadSourceStatus) => {
  switch (importType) {
    case PublicTransportDownloadSourceStatus.Failed:
        return "Failed";
    case PublicTransportDownloadSourceStatus.Success:
        return "Success";
    case PublicTransportDownloadSourceStatus.Ignored:
        return "Ignored";
    case PublicTransportDownloadSourceStatus.Patched:
        return "Patched";
  }
}